module.exports = __webpack_public_path__ + "static/media/platforms-win.98bec520.svg";